import { Injectable } from '@angular/core';
import { LoggerService } from 'src/app/core/services/logger.service';
import { UtilService } from 'src/app/core/services/util.service';
import {
  ICivicsProvidersConfig,
  IIbbaProvidersConfig,
  IGerentesPfProvidersConfig,
  IChannelProviderVariables,
  IRecuperacaoProviderConfig,
} from 'src/app/data/CXOne/interfaces/IChannelProviderVariables';

import { CXoneDigitalContact } from '@nice-devone/digital-sdk';
import { CxOneUtils } from 'src/app/data/CXOne/util/CxOneUtils';

export interface TemplateValuesChannelProviders {
  fieldNegocio: string;
  retrieveRecordCol: string;
  retrieveRecordTable: string;
  templateAusente: string;
  templateCreateSession: string;
  templateSessaoPadrao: string;
  triggerPlugin: string;
  itau_name: string;
  itau_u_lk: string;
  itau_u_nomeprojeto: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContactCenterMainService {
  public templateValuesChannelProvider: TemplateValuesChannelProviders;

  constructor(
    private logger: LoggerService,
    private utilService: UtilService,
  ) {
    this.templateValuesChannelProvider = {
      fieldNegocio: '',
      retrieveRecordCol: '',
      retrieveRecordTable: '',
      templateAusente: '',
      templateCreateSession: '',
      templateSessaoPadrao: '',
      triggerPlugin: '',
      itau_name: '',
      itau_u_lk: '',
      itau_u_nomeprojeto: '',
    };
  }

  public async loadTemplateValues(
    channel: string,
  ): Promise<TemplateValuesChannelProviders | null> {
    try {
      const channelProviderVariables = await this.getValues(channel);
      this.logger.info(
        'MAIN_SERVICE - channel provider values',
        JSON.stringify(channelProviderVariables),
      );

      const templateValues: TemplateValuesChannelProviders = {
        fieldNegocio: channelProviderVariables.fieldnegocio || '',
        retrieveRecordCol: channelProviderVariables.retrieveRecordCol || '',
        retrieveRecordTable: channelProviderVariables.retrieveRecordTable || '',
        templateAusente: channelProviderVariables.templateAusente || '',
        templateCreateSession:
          channelProviderVariables.templateCreateSession || '',
        templateSessaoPadrao: '',
        triggerPlugin: channelProviderVariables.triggerPlugin || '',
        itau_name: channelProviderVariables.itau_name || '',
        itau_u_lk: channelProviderVariables.itau_u_lk || '',
        itau_u_nomeprojeto: channelProviderVariables.itau_u_nomeprojeto || '',
      };

      this.templateValuesChannelProvider = templateValues;

      this.logger.info(
        'MAIN_SERVICE - Template values loaded: ',
        JSON.stringify(templateValues),
      );

      return templateValues;
    } catch (error) {
      this.logger.info('MAIN_SERVICE - ');
      return null;
    }
  }

  public getValues(channel: string): IChannelProviderVariables {
    const key = channel?.toUpperCase();

    if (key && ICivicsProvidersConfig?.[key]) {
      return ICivicsProvidersConfig[key];
    }

    if (key && IIbbaProvidersConfig?.[key]) {
      return IIbbaProvidersConfig[key];
    }

    if (key && IGerentesPfProvidersConfig?.[key]) {
      return IGerentesPfProvidersConfig[key];
    }

    if (key && IRecuperacaoProviderConfig?.[key]) {
      return IRecuperacaoProviderConfig[key];
    }

    return ICivicsProvidersConfig['DEFAULT'];
  }

  public async generatePopUrlFronDigitalContact(
    digitalContact: CXoneDigitalContact,
    operation: string,
  ): Promise<{ channel: string; popUrl: any } | null> {
    //Chamando metodo para extração dos attaches do digitalEvent e montar o popUrl
    const uJson = await CxOneUtils.ExtractDataObjectFromPopUrl(
      digitalContact.case,
    );

    if (!uJson) {
      this.logger.warn(
        `${operation} - Dados não extraídos do evento principal, ${JSON.stringify(uJson)}`,
      );
      return null;
    }

    this.logger.info(
      `${operation} - U_Json extraído do evento digital: ${JSON.stringify(uJson)}`,
    );

    const channel = uJson['DYNAMICS'];
    this.logger.info(`${operation} - Canal recuperado: ${channel}`);

    const popUrl = {
      u_json: uJson,
      contactId: digitalContact.caseId,
    };

    this.logger.info(
      `${operation} - PopUrl gerado do envento principal: ${JSON.stringify(popUrl)}`,
    );

    const result = {
      channel: channel,
      popUrl: popUrl,
    };

    return result;
  }
}
